module.exports = __webpack_public_path__ + "static/img/20221222095006708.1050b36.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/index/20221222095006708.jpg
// module id = rphH
// module chunks = 30